import { initializeFaro, getWebInstrumentations } from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  const faro = initializeFaro({
    url: 'https://metrics.devcertificates.com/collect',
    apiKey: '7WgfPYtngdMoumAHNAAIiWgK3wxS5O',
    consoleInstrumentation: {
      disabledLevels: []
    },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation()
    ],
    app: {
      name: 'certificates',
      environment: config.public.ENVIRONMENT_NAME
    }
  })
  return {
    provide: {
      faro
    }
  }
})
